/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let ShieldO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M531.716096 63.666176l312.651776 100.368384c28.043264 9.268224 46.784512 34.848768 46.51008 63.47776v412.238848c0 147.341312-274.743296 281.645056-358.908928 319.291392A51.794944 51.794944 0 0 1 510.738432 963.584a51.2256 51.2256 0 0 1-19.462144-3.88096c-84.165632-34.37568-358.904832-159.085568-358.15424-320.221184V227.463168c-0.24576-28.621824 18.486272-54.19008 46.514176-63.47776l310.882304-100.319232a66.893824 66.893824 0 0 1 41.197568 0z m-20.476928 55.689216c-0.77824 0.011264-1.548288 0.14336-2.282496 0.391168l-312.2176 100.318208c-3.171328 1.071104-5.302272 3.943424-5.327872 7.17824V639.52896c-0.505856 104.786944 198.846464 214.554624 319.321088 263.993344 160.546816-72.095744 321.855488-181.252096 321.855488-263.993344V227.414016c0.017408-3.280896-2.116608-6.21568-5.325824-7.323648l-313.740288-100.368384c-0.6144-0.190464-1.251328-0.3072-1.8944-0.350208l-0.388096-0.016384z m0.76288 152.947712c15.264768 0.078848 27.460608 12.397568 27.38176 27.51488l-0.999424 147.586048h148.779008c15.20128 0 27.52512 12.31872 27.52512 27.51488 0 15.197184-12.32384 27.516928-27.52512 27.516928H538.098688l-1.007616 148.871168c-0.075776 14.508032-11.862016 26.22976-26.375168 26.22976-14.491648 0-26.238976-11.743232-26.238976-26.22976V502.43584H336.841728c-15.202304 0-27.52512-12.31872-27.52512-27.515904 0-15.19616 12.322816-27.515904 27.52512-27.515904h147.6352V299.819008c0-15.19616 12.32384-27.515904 27.52512-27.515904z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

ShieldO.defaultProps = {
  size: 18,
};

ShieldO = React.memo ? React.memo(ShieldO) : ShieldO;

export default ShieldO;
